"use client";

import { useState, useEffect } from "react";
import { Menu, X, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-white/10 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-white/10 animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-white/10 animate-pulse rounded-md" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="flex items-center justify-center w-full">
        <Link to="/" className="hidden md:block mr-10">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/phoenix_enterprise_tcp_logo.png" className="h-9 w-auto object-contain transition-all duration-[var(--duration-medium)] hover:scale-105" alt="Phoenix Enterprises Limousine Service" />
        </Link>
        <NavigationMenuList className="hidden md:flex gap-6">
          {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-2 py-2 text-sm font-semibold text-primary-light hover:text-secondary focus:text-primary-dark hover:!bg-transparent focus:!bg-transparent transition-all duration-[var(--duration-medium)] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-secondary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full outline-none focus-visible:ring-1 focus-visible:ring-secondary/50 rounded-sm">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link to="https://www.facebook.com/reel/1326795919211492" newTab className="relative px-2 py-2 text-sm font-semibold text-primary-light hover:text-secondary focus:text-primary-dark hover:!bg-transparent focus:!bg-transparent transition-all duration-[var(--duration-medium)] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-secondary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full outline-none focus-visible:ring-1 focus-visible:ring-secondary/50 rounded-sm">
                Watch Reel
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
          <NavigationMenuItem>
            <NavigationMenuLink asChild>
              <Link to="https://www.facebook.com/reel/1326795919211492" newTab className="relative px-2 py-2 text-sm font-semibold text-primary-light hover:text-secondary focus:text-primary-dark hover:!bg-transparent focus:!bg-transparent transition-all duration-[var(--duration-medium)] after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[2px] after:bg-secondary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full flex items-center gap-2 outline-none focus-visible:ring-1 focus-visible:ring-secondary/50 rounded-sm">
                <Facebook className="size-4" />
                Facebook
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-primary-light/10 focus:bg-primary-light/10 focus-visible:ring-2 focus-visible:ring-secondary z-50 ml-auto transition-all" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" aria-expanded={mobileMenuOpen}>
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 w-full glass-effect border-t border-white/10 md:hidden z-40 bg-background/98 backdrop-blur-2xl shadow-strong animate-in slide-in-from-top-2 duration-300">
          <nav className="flex flex-col p-6 gap-2">
            <Link to="/" className="px-4 py-4 mb-4 border-b border-white/10" onClick={() => setMobileMenuOpen(false)}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/phoenix_enterprise_tcp_logo.png" className="h-8 w-auto" alt="Phoenix Enterprises Limousine Service" />
            </Link>
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="px-4 py-4 text-base font-medium text-foreground hover:text-white hover:bg-primary/5 rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
            <Link to="https://www.facebook.com/reel/1326795919211492" newTab className="px-4 py-4 text-base font-medium text-foreground hover:text-white hover:bg-primary/5 rounded-md transition-all duration-[var(--duration-medium)]" onClick={() => setMobileMenuOpen(false)}>
              Watch Reel
            </Link>
            <Link to="https://www.facebook.com/reel/1326795919211492" newTab className="px-4 py-4 text-base font-medium text-foreground hover:text-white hover:bg-primary/5 rounded-md transition-all duration-[var(--duration-medium)] flex items-center gap-2" onClick={() => setMobileMenuOpen(false)}>
              <Facebook className="size-5" />
              Facebook
            </Link>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-[var(--duration-medium)] ${isScrolled ? "bg-background/95 backdrop-blur-md border-b border-border shadow-soft py-2" : "bg-transparent py-4"}`}>
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
        <div className="flex items-center gap-4 md:hidden">
          <Link to="/" className="block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/phoenix_enterprise_tcp_logo.png" className="h-9 w-auto object-contain" alt="Phoenix Enterprises Limousine Service" />
          </Link>
        </div>

        <div className="flex items-center gap-8 w-full justify-between bg-primary-dark/40 backdrop-blur-md border border-white/10 p-1.5 rounded-lg shadow-medium md:justify-start overflow-hidden relative">
          <div className="absolute inset-0 bg-[url(https://phoenixlimo.info/wp-content/uploads/2026/02/Screenshot-2026-02-18-164015.jpg)] bg-cover bg-center opacity-20 pointer-events-none" />
          
          <MenuProvider menu_id="41" className="relative z-10 flex-1">
            <HeaderMenuConsumer />
          </MenuProvider>
          
          <Link to="/OnlineBookingPage" className="hidden lg:block ml-auto relative z-10">
            
          </Link>
        </div>
      </div>
    </header>;
}